var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 163,
    viewBox: "0 0 149 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.8929 77.361C87.8929 77.361 87.8929 77.2175 87.8929 77.1377V55.1022L65.1266 46.1572L62.6308 46.4761V68.7349C62.5988 69.3727 62.9668 69.9945 63.7667 70.4569L79.7335 79.6729C81.4134 80.6456 84.3572 80.518 86.293 79.4019C87.301 78.8279 87.8449 78.0785 87.8929 77.3769V77.361Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.7333 57.414L63.7665 48.198C62.0866 47.2254 62.2946 45.5352 64.2304 44.4191C66.1663 43.303 69.1101 43.1754 70.7899 44.148L86.7567 53.3641C88.4366 54.3367 88.2286 56.0268 86.2928 57.1429C84.3569 58.2591 81.4131 58.3866 79.7333 57.414Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72.7573 70.4416L70.6935 69.2617V64.0956C69.7656 63.1389 69.1416 61.7517 69.1416 60.5877C69.1416 59.7586 69.4456 59.1368 69.9735 58.8179C70.5175 58.499 71.2054 58.5628 71.9254 58.9773C73.3013 59.7746 74.3892 61.6401 74.3892 63.2186C74.3892 63.9361 74.1492 64.5261 73.7333 64.8609C73.4613 65.0682 73.1093 65.1798 72.7573 65.1798V70.4734V70.4416Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M68.9502 47.7999V41.0553C68.9502 40.3697 69.1422 39.6841 69.5102 39.1101C69.8941 38.5042 70.4541 38.0418 71.126 37.8026L72.038 37.4678L71.35 38.3288L71.046 39.5725L70.982 46.7635L70.6141 47.6086L68.9502 47.8159V47.7999Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M82.3731 55.4053H81.1412C80.2612 55.4053 79.5253 54.6878 79.5253 53.7949V47.5127C79.5253 44.244 77.1255 40.1144 74.2937 38.488C73.3658 37.9459 72.4858 37.7864 72.0219 38.0416C71.5579 38.3126 71.2699 39.1417 71.2699 40.21V46.4922C71.2699 47.3692 70.55 48.1026 69.6541 48.1026H68.4381C67.5582 48.1026 66.8223 47.3851 66.8223 46.4922V40.21C66.8223 37.4835 67.9102 35.2831 69.798 34.1989C71.6859 33.1147 74.1337 33.2741 76.5015 34.6453C80.6772 37.053 83.957 42.6974 83.957 47.5127V53.7949C83.957 54.6719 83.237 55.4053 82.3411 55.4053H82.3731Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M127.638 77.4755C127.638 104.717 103.782 117.245 93.0952 117.245C53.5218 117.261 27.7109 77.4755 27.7109 41.7593C27.7109 19.5124 41.9061 1 68.9346 1C87.1031 1 127.638 25.8322 127.638 77.4915V77.4755Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M113.408 118.551C119.628 118.551 124.671 113.525 124.671 107.326C124.671 101.126 119.628 96.1006 113.408 96.1006C107.187 96.1006 102.145 101.126 102.145 107.326C102.145 113.525 107.187 118.551 113.408 118.551Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M121.375 99.3851C120.687 98.6995 119.919 98.1255 119.119 97.6631C121.663 101.968 121.103 107.597 117.391 111.296C113.679 114.995 108.032 115.569 103.712 113.018C104.192 113.815 104.752 114.58 105.44 115.266C109.839 119.651 116.975 119.651 121.375 115.266C125.774 110.881 125.774 103.77 121.375 99.3851Z",
    fill: "#0F1936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M113.408 41.3329C119.628 41.3329 124.671 36.3073 124.671 30.1079C124.671 23.9084 119.628 18.8828 113.408 18.8828C107.187 18.8828 102.145 23.9084 102.145 30.1079C102.145 36.3073 107.187 41.3329 113.408 41.3329Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M121.375 22.1517C120.687 21.4661 119.919 20.8921 119.119 20.4297C121.663 24.7348 121.103 30.3632 117.391 34.0624C113.679 37.7616 108.032 38.3356 103.712 35.7844C104.192 36.5816 104.752 37.347 105.44 38.0326C109.839 42.4174 116.975 42.4174 121.375 38.0326C125.774 33.6478 125.774 26.5365 121.375 22.1517Z",
    fill: "#0F1936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.9272 32.6317C39.1477 32.6317 44.1904 27.6061 44.1904 21.4067C44.1904 15.2073 39.1477 10.1816 32.9272 10.1816C26.7067 10.1816 21.6641 15.2073 21.6641 21.4067C21.6641 27.6061 26.7067 32.6317 32.9272 32.6317Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.8941 13.4662C40.2062 12.7805 39.4382 12.2065 38.6383 11.7441C41.1821 16.0492 40.6221 21.6777 36.9104 25.3768C33.1987 29.076 27.5511 29.65 23.2314 27.0989C23.7114 27.8961 24.2714 28.6614 24.9593 29.3471C29.359 33.7319 36.4944 33.7319 40.8941 29.3471C45.2938 24.9623 45.2938 17.851 40.8941 13.4662Z",
    fill: "#0F1936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.8387 63.1875C22.8387 63.1875 22.8236 63.1875 22.8086 63.1875C22.8086 63.1875 22.8236 63.1875 22.8387 63.1875Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.165 128.034C66.261 127.811 66.389 127.604 66.485 127.397C67.077 126.089 67.5729 124.75 67.9889 123.395C67.5729 124.75 67.077 126.073 66.485 127.397C66.389 127.62 66.277 127.827 66.165 128.034Z",
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.485 127.397C66.389 127.604 66.261 127.811 66.165 128.034C66.277 127.827 66.389 127.62 66.485 127.397ZM66.485 127.397C67.077 126.089 67.5729 124.75 67.9889 123.395C67.5729 124.75 67.077 126.073 66.485 127.397Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M62.4375 87.0889C63.8294 89.4965 65.0133 91.9839 66.0212 94.535C65.0293 91.9839 63.8294 89.4965 62.4375 87.0889Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M36.9016 64.6225C33.4139 63.3948 29.7982 62.7251 26.0225 62.8846",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M45.3506 68.7363C47.7344 70.2351 49.9422 71.9412 52.0061 73.8546C49.9422 71.9572 47.7344 70.2351 45.3506 68.7363Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7174 80.0892C59.4773 82.3533 61.0612 84.6813 62.4371 87.0889C61.0452 84.6813 59.4773 82.3533 57.7174 80.0892C55.9576 77.841 54.0697 75.7363 52.0059 73.8389C54.0697 75.7363 55.9576 77.825 57.7174 80.0892Z",
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7174 80.0892C59.4773 82.3533 61.0612 84.6813 62.4371 87.0889C61.0452 84.6813 59.4773 82.3533 57.7174 80.0892ZM57.7174 80.0892C55.9576 77.841 54.0697 75.7363 52.0059 73.8389C54.0697 75.7363 55.9576 77.825 57.7174 80.0892Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M69.4604 110.846C69.2524 106.525 68.5484 102.396 67.3645 98.4415C66.9646 97.1181 66.5326 95.8266 66.0206 94.551C65.0287 91.9999 63.8288 89.5125 62.4369 87.1049C61.045 84.6972 59.4771 82.3693 57.7173 80.1051C55.9574 77.8569 54.0695 75.7522 52.0057 73.8548C49.9418 71.9574 47.734 70.2354 45.3502 68.7366C44.5503 68.2423 43.7343 67.764 42.9024 67.3016C42.0704 66.8392 41.2225 66.4246 40.3426 66.0101C39.2067 65.4839 38.0547 65.0215 36.9028 64.6069C33.4151 63.3792 29.7994 62.7095 26.0237 62.8689C24.9997 62.9168 24.0078 63.0124 23.0479 63.156C22.9839 63.156 22.9039 63.156 22.8399 63.1719C22.8399 63.1719 22.8239 63.1719 22.8079 63.1719C19.7041 63.6502 16.9204 64.6229 14.4245 66.0419V66.0101C10.3928 68.3061 7.14509 71.8139 4.68128 76.4857C2.00948 81.5561 0.953564 87.0092 1.00156 90.6605C1.03356 100.291 2.84142 107.45 6.05718 114.291C9.17694 120.892 13.3686 126.711 18.7922 131.622C24.0398 136.39 29.9754 139.961 36.9508 141.572C43.3183 143.039 49.5259 142.688 55.3974 139.547C58.6932 137.777 61.349 135.417 63.4448 132.563C64.4687 131.176 65.3647 129.645 66.1486 128.035C66.2446 127.812 66.3726 127.604 66.4686 127.397C67.0605 126.09 67.5565 124.75 67.9725 123.395C68.3885 122.04 68.7084 120.684 68.9484 119.297C69.4284 116.539 69.5724 113.717 69.4444 110.846H69.4604ZM36.5669 132.643C31.1913 131.415 26.6156 128.657 22.5679 124.973C18.3922 121.195 15.1605 116.714 12.7607 111.628C10.2809 106.366 8.88896 100.849 8.85696 93.4189C8.82497 90.6127 9.64091 86.4033 11.7047 82.4968C13.2726 79.5311 15.2565 77.2032 17.6403 75.4652C20.5361 73.3605 24.0238 72.1647 28.1515 71.9893C32.0232 71.8299 35.6869 72.8025 39.1907 74.4129C44.5663 76.9003 48.9659 80.6154 52.5657 85.2553C57.9892 92.2231 61.189 100.068 61.605 108.949C61.813 113.366 61.141 117.655 59.3171 121.705C57.4933 125.739 54.7415 128.96 50.7898 131.08C50.6298 131.16 50.4858 131.224 50.3258 131.304C45.9422 133.504 41.3185 133.727 36.5829 132.643H36.5669Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M22.0567 104.739C18.8249 97.899 17.017 90.7398 17.001 81.1093C16.985 79.5148 17.193 77.5695 17.641 75.4648C15.2572 77.1869 13.2733 79.5148 11.7054 82.4964C9.65759 86.4029 8.84165 90.6123 8.85765 93.4185C8.87365 100.833 10.2655 106.35 12.7614 111.627C15.1612 116.714 18.3929 121.194 22.5686 124.973C26.6163 128.64 31.192 131.399 36.5676 132.642C41.3032 133.727 45.9268 133.488 50.3105 131.303C44.455 129.469 39.3513 126.233 34.7917 122.071C29.3841 117.16 25.1764 111.34 22.0567 104.739Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M22.8076 63.1875C19.7038 63.6499 16.904 64.6066 14.4082 66.0257V66.0575C16.92 64.6385 19.7038 63.6499 22.8076 63.1875Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M63.4605 132.563C61.3486 135.418 58.7088 137.777 55.4131 139.547C58.7088 137.777 61.3646 135.418 63.4605 132.563Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M23.0488 63.1553C22.9848 63.1553 22.9048 63.1712 22.8408 63.1872C22.9048 63.1872 22.9848 63.1872 23.0488 63.1712V63.1553Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M81.8111 103.879C81.2671 92.3665 77.1074 82.1778 70.068 73.1213C65.3803 67.1101 59.6848 62.2789 52.6933 59.0581C48.1496 56.9534 43.398 55.7097 38.3744 55.917C33.8947 56.0924 30.007 57.2244 26.6313 59.1856L26.5993 59.1697L14.4082 66.0099V66.0418C16.92 64.6228 19.7038 63.6661 22.8076 63.2037C22.8076 63.2037 22.8236 63.2037 22.8396 63.2037C22.9036 63.2037 22.9836 63.1877 23.0475 63.1718C24.0075 63.0442 24.9994 62.9326 26.0233 62.9007C29.799 62.7413 33.4148 63.411 36.9025 64.6387C38.0704 65.0533 39.2063 65.5157 40.3422 66.0418C41.2222 66.4405 42.0701 66.871 42.902 67.3333C43.734 67.7957 44.5499 68.2581 45.3499 68.7684C47.7337 70.2672 49.9415 71.9733 52.0054 73.8866C54.0692 75.784 55.9571 77.8728 57.7169 80.1369C59.4768 82.4011 61.0607 84.729 62.4366 87.1366C63.8285 89.5443 65.0124 92.0317 66.0203 94.5828C66.5162 95.8584 66.9642 97.1658 67.3642 98.4733C68.5481 102.428 69.252 106.557 69.46 110.878C69.604 113.748 69.46 116.571 68.9641 119.329C68.7241 120.716 68.4041 122.071 67.9881 123.427C67.5722 124.782 67.0762 126.105 66.4843 127.429C66.3883 127.652 66.2763 127.859 66.1643 128.067C65.3803 129.677 64.5004 131.208 63.4605 132.595C61.3486 135.449 58.7088 137.809 55.4131 139.579L69.236 131.814C70.18 131.224 71.0119 130.458 71.8438 129.757C74.8516 127.269 77.1714 124.144 78.8513 120.461C81.2351 115.199 82.0991 109.635 81.8271 103.91L81.8111 103.879Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9651 119.297C69.4451 116.539 69.5891 113.716 69.4611 110.846C69.6051 113.716 69.4611 116.539 68.9651 119.297Z",
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4611 110.846C69.5891 113.716 69.4451 116.539 68.9651 119.297C69.4611 116.539 69.6051 113.716 69.4611 110.846ZM69.4611 110.846C69.2531 106.525 68.5491 102.396 67.3652 98.4414",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M26.0246 62.8851C25.0007 62.9329 24.0088 63.0286 23.0488 63.1561C24.0088 63.0126 25.0007 62.917 26.0246 62.8691V62.8851Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9019 67.3011C42.07 66.8546 41.222 66.4241 40.3421 66.0096C39.2062 65.4834 38.0543 65.021 36.9023 64.6064C38.0703 65.021 39.2062 65.4834 40.3421 66.0096C41.222 66.4082 42.07 66.8387 42.9019 67.3011Z",
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3421 66.0096C41.222 66.4241 42.07 66.8546 42.9019 67.3011C42.07 66.8387 41.222 66.4082 40.3421 66.0096ZM40.3421 66.0096C39.2062 65.4834 38.0543 65.021 36.9023 64.6064C38.0703 65.021 39.2062 65.4834 40.3421 66.0096Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M63.4609 132.563C64.4849 131.176 65.3808 129.646 66.1647 128.035C65.3808 129.646 64.5009 131.176 63.4609 132.563Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M145.886 150.612L79.5867 110.081C79.5867 110.081 79.4907 110.017 79.4427 109.985C78.6108 109.507 77.4589 109.571 76.179 110.288C73.5872 111.723 71.4593 115.295 71.4113 118.245C71.3953 119.871 72.4512 121.067 72.9792 121.386L139.486 162.045L145.87 150.612H145.886Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M146.206 150.772C145.15 150.15 143.806 150.214 142.43 150.995C139.918 152.398 137.918 155.73 137.87 158.6C137.854 160.179 138.414 161.391 139.47 162.029C139.934 162.316 140.478 162.443 141.038 162.443C141.742 162.443 142.494 162.236 143.262 161.805C145.774 160.402 147.774 157.07 147.822 154.2C147.838 152.621 147.278 151.409 146.222 150.772H146.206Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafely);
export default __webpack_public_path__ + "static/media/safely.c37c8413b0a872cb5317d679ed2ea23c.svg";
export { ForwardRef as ReactComponent };